// Mock data for Downtime Artist portfolio

export const artistInfo = {
  name: "niki",
  fullName: "Nikhita Kapur",
  bio: "I am a New York-based abstract painter working primarily on large-scale paintings using acrylic paint alongside organic materials such as seeds, spices, and coffee. My current body of work, Architecture of Panic, uses underwater diving and the depths of the ocean as a visual metaphor for how pressure and stress are experienced and stored in the body. The paintings trace the journey of panic\u2014from its accumulation and physical weight to its eventual release\u2014exploring what we hold onto, what becomes embedded, and what we ultimately let go.\n\nMy early work received recognition from the Tretyakov Art Gallery in Russia and a President\u2019s Award from Shankar\u2019s International Art Competition in India. I have further developed my practice through studies with Larry Poons and Peter Reginato at the Art Students League of New York, where I am a 2026\u201327 scholarship recipient. I am currently based in New York, and my work is held in private collections in India and the United States.",
  photo: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/je4gdyqh_9CBAC864-B766-4425-B3BC-63434B30339E_1_105_c.jpeg",
  email: "downtimeartist@gmail.com",
  social: {
    instagram: "@downtimeartist"
  }
};

// Carousel images for home page - arranged: 2 similar + 1 different (taller) in middle per slide
export const carouselImages = [
  // Slide 1: [20×20, 48×16, 20×20]
  { id: 1, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/u4jvr2el_Central%20Logic_20x20.JPG", title: "Mixed media on canvas", name: "Central Logic", size: "20 × 20 inches", year: "2026" },
  { id: 2, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/1aj5ebs4_Constant%20Exhale_48x16.webp", title: "Mixed media on canvas", name: "Constant Exhale", size: "48 × 16 inches", year: "2026" },
  { id: 3, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/tafqpwoy_The%20System%20Takes%20Hold_20x20.webp", title: "Mixed media on canvas", name: "The System Takes Hold", size: "20 × 20 inches", year: "2026" },
  // Slide 2: [20×20, 48×16, 20×20]
  { id: 4, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/r3ylh0pf_Necessary%20Breath_20x20.webp", title: "Mixed media on canvas", name: "Necessary Breath", size: "20 × 20 inches", year: "2026" },
  { id: 5, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/oooay1rq_What%20Survives_48x16.webp", title: "Mixed media on canvas", name: "What Survives", size: "48 × 16 inches", year: "2026" },
  { id: 6, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/71a0homu_Waiting%20Room_20x20.JPG", title: "Mixed media on canvas", name: "Waiting Room", size: "20 × 20 inches", year: "2026" },
  // Slide 3: [20×30, 48×16, 20×30]
  { id: 7, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/j19bt7fq_Pressure%20Fracture_20x30.JPG", title: "Mixed media on canvas", name: "Pressure Fracture", size: "20 × 30 inches", year: "2026" },
  { id: 8, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/pb0ycvn2_Incursion_48x16.webp", title: "Mixed media on canvas", name: "Incursion", size: "48 × 16 inches", year: "2026" },
  { id: 9, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/oda6mlef_Inner%20Reserve_20x30.JPG", title: "Mixed media on canvas", name: "Inner Reserve", size: "20 × 30 inches", year: "2026" },
  // Slide 4: [36×36, 48×16, 36×36]
  { id: 10, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/shtzunl2_The%20Break%20Opens_36x36.webp", title: "Mixed media on canvas", name: "The Break Opens", size: "36 × 36 inches", year: "2026" },
  { id: 11, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/4wjfugn7_Passage_48x16.webp", title: "Mixed media on canvas", name: "Passage", size: "48 × 16 inches", year: "2026" },
  { id: 12, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/erzt191k_What%20Breaks%20Through_36x36.webp", title: "Mixed media on canvas", name: "What Breaks Through", size: "36 × 36 inches", year: "2026" },
  // Slide 5: [36×36, 48×16, 36×36]
  { id: 13, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/r7jwp7tx_Hunger%20For%20Grounding_36x36.webp", title: "Mixed media on canvas", name: "Hunger For Grounding", size: "36 × 36 inches", year: "2026" },
  { id: 14, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/37pan9t3_Nikhita%20Kapur_The%20Depth%20of%20Breath_48x16.webp", title: "Mixed media on canvas", name: "The Depth of Breath", size: "48 × 16 inches", year: "2026" },
  { id: 15, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/i366qusa_Points%20Of%20Tension_36x36.webp", title: "Mixed media on canvas", name: "Points Of Tension", size: "36 × 36 inches", year: "2026" },
  // Slide 6: [48×36, 48×48, 48×36]
  { id: 16, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/t9oen5mt_Falling%20Back%20Into%20Place_48x36.webp", title: "Mixed media on canvas", name: "Falling Back Into Place", size: "48 × 36 inches", year: "2026" },
  { id: 17, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/cy66owxu_Nikhita%20Kapur_Nothing%20Stays%20Still_48x48.jpeg", title: "Mixed media on canvas", name: "Nothing Stays Still", size: "48 × 48 inches", year: "2026" },
  { id: 18, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/drmth8dy_Crosscurrent_48x36.webp", title: "Mixed media on canvas", name: "Crosscurrent", size: "48 × 36 inches", year: "2026" },
  // Slide 7: [36×48, 60×36] — 2 remaining singles
  { id: 19, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/ec0gbi8p_Pressure%20Current_36x48.webp", title: "Mixed media on canvas", name: "Pressure Current", size: "36 × 48 inches", year: "2026" },
  { id: 20, url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/nds2jrhj_Forced%20Open_60x36.webp", title: "Mixed media on canvas", name: "Forced Open", size: "60 × 36 inches", year: "2026" }
];

// Architecture of Panic collection images (formerly Underwater) - 20 paintings
export const architectureOfPanicImages = [
  {
    id: 1,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/u4jvr2el_Central%20Logic_20x20.JPG",
    name: "Central Logic",
    title: "Mixed media on canvas",
    size: "20 × 20 inches",
    year: "2026"
  },
  {
    id: 2,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/tafqpwoy_The%20System%20Takes%20Hold_20x20.webp",
    name: "The System Takes Hold",
    title: "Mixed media on canvas",
    size: "20 × 20 inches",
    year: "2026"
  },
  {
    id: 3,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/r3ylh0pf_Necessary%20Breath_20x20.webp",
    name: "Necessary Breath",
    title: "Mixed media on canvas",
    size: "20 × 20 inches",
    year: "2026"
  },
  {
    id: 4,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/71a0homu_Waiting%20Room_20x20.JPG",
    name: "Waiting Room",
    title: "Mixed media on canvas",
    size: "20 × 20 inches",
    year: "2026"
  },
  {
    id: 5,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/j19bt7fq_Pressure%20Fracture_20x30.JPG",
    name: "Pressure Fracture",
    title: "Mixed media on canvas",
    size: "20 × 30 inches",
    year: "2026"
  },
  {
    id: 6,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/oda6mlef_Inner%20Reserve_20x30.JPG",
    name: "Inner Reserve",
    title: "Mixed media on canvas",
    size: "20 × 30 inches",
    year: "2026"
  },
  {
    id: 7,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/shtzunl2_The%20Break%20Opens_36x36.webp",
    name: "The Break Opens",
    title: "Mixed media on canvas",
    size: "36 × 36 inches",
    year: "2026"
  },
  {
    id: 8,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/erzt191k_What%20Breaks%20Through_36x36.webp",
    name: "What Breaks Through",
    title: "Mixed media on canvas",
    size: "36 × 36 inches",
    year: "2026"
  },
  {
    id: 9,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/r7jwp7tx_Hunger%20For%20Grounding_36x36.webp",
    name: "Hunger For Grounding",
    title: "Mixed media on canvas",
    size: "36 × 36 inches",
    year: "2026"
  },
  {
    id: 10,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/i366qusa_Points%20Of%20Tension_36x36.webp",
    name: "Points Of Tension",
    title: "Mixed media on canvas",
    size: "36 × 36 inches",
    year: "2026"
  },
  {
    id: 11,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/37pan9t3_Nikhita%20Kapur_The%20Depth%20of%20Breath_48x16.webp",
    name: "The Depth of Breath",
    title: "Mixed media on canvas",
    size: "48 × 16 inches",
    year: "2026"
  },
  {
    id: 12,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/1aj5ebs4_Constant%20Exhale_48x16.webp",
    name: "Constant Exhale",
    title: "Mixed media on canvas",
    size: "48 × 16 inches",
    year: "2026"
  },
  {
    id: 13,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/oooay1rq_What%20Survives_48x16.webp",
    name: "What Survives",
    title: "Mixed media on canvas",
    size: "48 × 16 inches",
    year: "2026"
  },
  {
    id: 14,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/pb0ycvn2_Incursion_48x16.webp",
    name: "Incursion",
    title: "Mixed media on canvas",
    size: "48 × 16 inches",
    year: "2026"
  },
  {
    id: 15,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/4wjfugn7_Passage_48x16.webp",
    name: "Passage",
    title: "Mixed media on canvas",
    size: "48 × 16 inches",
    year: "2026"
  },
  {
    id: 16,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/cy66owxu_Nikhita%20Kapur_Nothing%20Stays%20Still_48x48.jpeg",
    name: "Nothing Stays Still",
    title: "Mixed media on canvas",
    size: "48 × 48 inches",
    year: "2026"
  },
  {
    id: 17,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/t9oen5mt_Falling%20Back%20Into%20Place_48x36.webp",
    name: "Falling Back Into Place",
    title: "Mixed media on canvas",
    size: "48 × 36 inches",
    year: "2026"
  },
  {
    id: 18,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/drmth8dy_Crosscurrent_48x36.webp",
    name: "Crosscurrent",
    title: "Mixed media on canvas",
    size: "48 × 36 inches",
    year: "2026"
  },
  {
    id: 19,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/ec0gbi8p_Pressure%20Current_36x48.webp",
    name: "Pressure Current",
    title: "Mixed media on canvas",
    size: "36 × 48 inches",
    year: "2026"
  },
  {
    id: 20,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/nds2jrhj_Forced%20Open_60x36.webp",
    name: "Forced Open",
    title: "Mixed media on canvas",
    size: "60 × 36 inches",
    year: "2026"
  }
];

// Memory in Transit collection images — 6 paintings
export const memoryInTransitImages = [
  {
    id: 1,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/thovl588_Crossfade_30x40.webp",
    name: "Crossfade",
    title: "Acrylic on canvas",
    size: "30 × 40 inches",
    year: "2025"
  },
  {
    id: 2,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/3gjmntlm_The%20Places%20We%20Carry_30x40.webp",
    name: "The Places We Carry",
    title: "Acrylic on canvas",
    size: "30 × 40 inches",
    year: "2025"
  },
  {
    id: 3,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/3d1eqcr8_Rooted_30x40.webp",
    name: "Rooted",
    title: "Acrylic on canvas",
    size: "30 × 40 inches",
    year: "2025"
  },
  {
    id: 4,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/gduom5sh_Bloom_30x40.webp",
    name: "Bloom",
    title: "Acrylic on canvas",
    size: "30 × 40 inches",
    year: "2025"
  },
  {
    id: 5,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/60o4knca_Melting%20Heartbeat_30x40.webp",
    name: "Melting Heartbeat",
    title: "Acrylic on canvas",
    size: "30 × 40 inches",
    year: "2025"
  },
  {
    id: 6,
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/ss8qoak2_Fragmented%20Devotion_20x30.webp",
    name: "Fragmented Devotion",
    title: "Acrylic on canvas",
    size: "30 × 40 inches",
    year: "2025"
  }
];

// Memory in Transit hero — carousel of the collection paintings
export const memoryInTransitHero = {
  carousel: true
};

// Calm in Chaos collection images — 2 paintings
export const calmInChaosImages = [
  {
    id: 1,
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_5f2abc08-b233-4937-9392-18480a2a3cbb/artifacts/x38x3j40_IMG_7688.webp",
    name: "A Quiet Permission",
    title: "Mixed media on canvas",
    size: "22 × 30 inches",
    year: "2026"
  },
  {
    id: 2,
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_5f2abc08-b233-4937-9392-18480a2a3cbb/artifacts/xvuiqwcc_IMG_7689.webp",
    name: "Inner Hold",
    title: "Mixed media on canvas",
    size: "22 × 30 inches",
    year: "2026"
  }
];

// Work collections
export const collections = {
  architectureOfPanic: {
    title: "Architecture of Panic",
    slug: "architecture-of-panic",
    year: "2026",
    description: "Architecture of Panic uses underwater diving and the depths of the ocean as a visual metaphor for how pressure and stress are experienced and stored in the human body. The paintings follow the journey of panic—from its accumulation and physical weight to its release—exploring what we hold onto, what becomes embedded, and what we eventually let go.",
    images: architectureOfPanicImages,
    hero: { carousel: true }
  },
  memoryInTransit: {
    title: "Memory in Transit",
    slug: "memory-in-transit",
    year: "2025",
    description: "Memory In Transit explores the degradation and survival of identity during global migration. By mapping the tension between the physical places we lose and the fragmented versions we carry within us.",
    images: memoryInTransitImages,
    hero: memoryInTransitHero
  },
  calmInChaos: {
    title: "Calm in Chaos",
    slug: "calm-in-chaos",
    year: "2026",
    description: "Calm in Chaos explores finding stillness within turbulence—moments of quiet surrender amid the noise of modern life.",
    images: calmInChaosImages,
    hero: { carousel: true }
  }
};

// Homepage "Select Paintings" carousel — curated subset of AoP
export const homepageSelectPaintings = [
  architectureOfPanicImages.find(p => p.name === "Nothing Stays Still"),
  architectureOfPanicImages.find(p => p.name === "Crosscurrent"),
  architectureOfPanicImages.find(p => p.name === "Falling Back Into Place"),
  architectureOfPanicImages.find(p => p.name === "The Depth of Breath"),
  architectureOfPanicImages.find(p => p.name === "Constant Exhale"),
  architectureOfPanicImages.find(p => p.name === "Inner Reserve"),
  architectureOfPanicImages.find(p => p.name === "Pressure Fracture"),
  architectureOfPanicImages.find(p => p.name === "The System Takes Hold"),
  architectureOfPanicImages.find(p => p.name === "Central Logic"),
  architectureOfPanicImages.find(p => p.name === "Waiting Room"),
].filter(Boolean);

export const allArtworks = [...architectureOfPanicImages, ...memoryInTransitImages, ...calmInChaosImages];
